<form layout-full-width layout-vertical layout-space-between margin-bottom-small>
  @for (
    invitationControl of invitationForm.controls;
    track trackByControl(index, invitationControl);
    let isFirst = $first;
    let index = $index
  ) {
    <div [class.has-right-padding]="isFirst" margin-top-small layout-vertical>
      <div layout-horizontal layout-align-items-end>
        <rt-form-field [required]="invitationControl.get('email')!.invalid" margin-right>
          <rt-label>{{ 'app.invitation_form.email' | translate }}</rt-label>
          <rt-input
            variant="rounded"
            [placeholder]="
              'app.offer_assignments.offer_team_members_dialog.email_field_placeholder' | translate
            "
            [formControl]="$any(invitationControl.get('email'))"
          />
        </rt-form-field>
        <rt-form-field [required]="invitationControl.get('roleId')!.invalid">
          <rt-label>{{ 'app.invitation_form.role' | translate }}</rt-label>
          <rt-select
            [options]="roles"
            [required]="true"
            [placeholder]="'app.invitation_form.role' | translate"
            [formControl]="$any(invitationControl.get('roleId'))"
          />
        </rt-form-field>
        @if (!isFirst) {
          <rt-icon-button
            (click)="removeInvitationForm(index)"
            class="delete-action danger-on-hover"
            variant="plain"
            margin-left-small
            iconName="delete"
            shape="square"
          />
        }
      </div>
      @for (
        error of getErrorMessages(invitationControl.get('email')!);
        track trackByError($index, error)
      ) {
        <div class="error" margin-top-small-xx>
          <span [innerHTML]="error"></span>
        </div>
      }
    </div>
  }
</form>
<rt-group margin-bottom-small>
  <rt-button (click)="addInvitationForm()" variant="plain">
    <rt-icon name="add" />
    <span>{{ 'app.offer_assignments.offer_team_members_dialog.invite_more' | translate }}</span>
  </rt-button>
</rt-group>
